export default __webpack_public_path__ + "static/media/Neophyte's Bracers of Imperial Assent.4bf45c3c.jpg";